import React, { FC } from 'react';

import { colorOpacity, customTheme } from 'theme';

import { PageHeaderWithIcon } from 'components/DataDisplay';
import { IconTypes } from 'components/Icons';
import { Modal } from 'components/Overlay';
import { CVEAdditionalDetails } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/CVE/CVEAdditionalDetails';

interface Props {
  cveDetails: Record<string, any>;
  isOpen: boolean;
  onClose: () => void;
}

export const CVEAdditionalDetailsModal: FC<Props> = props => {
  const { cveDetails, isOpen, onClose } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="4xl"
      header={
        <PageHeaderWithIcon
          iconType={IconTypes.Vulnerabilities}
          label={cveDetails?.vulnerability_id ?? cveDetails?.cve_id}
          iconColor={customTheme.colors?.[cveDetails?.severity?.toLowerCase()]}
          useCustomColor
          iconBgColor={colorOpacity(
            customTheme.colors?.[cveDetails?.severity?.toLowerCase()],
            0.1,
          )}
          border={false}
        />
      }
      body={
        <CVEAdditionalDetails
          data={cveDetails}
          verticalSpacing={4}
          headerFontSize="18px"
        />
      }
      styles={{ body: { pt: 6 } }}
    />
  );
};
